import React from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Cards/Card";
import SecondaryBtn from "../../components/button/SecondaryBtn";
import Swal from "sweetalert2";
import DeleteSwal from "../../components/Swals/DeleteSwal";
import { FaArrowLeft } from "react-icons/fa";

const SubsciptionPlan = () => {
  const navigate = useNavigate();

  const cardsData = [
    {
      id: 1,
      varient: "subscribe",
      title: "Starter Plan",
      orders: "00",
      selectedPlan: true,
    },
    {
      id: 2,
      varient: "subscribe",
      title: "Growth Plan",
      orders: "20",
      selectedPlan: false,
    },
  ];

  const onHandleSubscancel = () => {
    DeleteSwal({
      title: "Cancel Subscription plan?",
      text: "Are you sure you want to Cancel this Plan?",
      confirmText: "Yes cancel plan",
      cancelText: "No",
      note: "",
      onConfirm: () => {
        Swal.fire({
          icon: "success",
          title: "Cancel!",
          text: "Plan has been Canceled successfully.",
          confirmButtonColor: "#FF6943",
        });
      },
    });
  };

  return (
    <section className="relative max-w-7xl xl:max-w-6xl   mx-auto px-4 md:px-6 py-10 pb-32 md:pb-10">
      <DecorativeSquares />

      {/* ================= HEADER ================= */}
      <div className="flex items-center justify-between bg-white px-5 md:px-6 py-4 rounded-2xl shadow-sm">
        <button
          onClick={() => navigate("/profile")}
          className="p-2 rounded-full hover:bg-gray-100 transition"
        >
          <FaArrowLeft size={20} />
        </button>

        <h1 className="text-lg md:text-2xl font-semibold text-gray-900">
          Subscription Plan
        </h1>

        {/* spacer */}
        <div className="w-10" />
      </div>

      {/* ================= PLANS ================= */}
      <div className="mt-12 flex justify-center">
        <div className="w-full xl:w-[85%] 2xl:w-[80%]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 p-8">
            {cardsData.map((data) => (
              <Card
                key={data.id}
                title={data.title}
                orders={data.orders}
                varient={data.varient}
                selectedPlan={data.selectedPlan}
                onViewPlan={() => navigate("/profile/view-plan")}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ================= ACTIONS ================= */}
      <div
        className="
                fixed md:relative
                bottom-0 left-0
                w-full md:w-auto
                bg-white
                md:bg-transparent
                md:shadow-none
                shadow-[0_-4px_20px_rgba(0,0,0,0.08)]
                px-4 md:px-0
                py-4 md:py-0
                z-30
              "
      >
        <div
          className="
                max-w-4xl  
                mx-auto
                bg-white
                md:rounded-2xl
                md:shadow-sm
                px-4 md:px-8
                py-4 md:py-6
                flex flex-col sm:flex-row
                items-center
                justify-between
                gap-4
              "
        >
          <SecondaryBtn
            clickEvent={onHandleSubscancel}
            btnName="Cancel Subscription"
            extraClass="
                bg-transparent 
                border border-red-500 
                text-red-500 
                hover:bg-red-50 
                hover:!text-red-500 
              "
          />

          <p
            className="text-sm text-[#FF6943] hover:underline cursor-pointer"
            onClick={() => navigate("/subscription-history")}
          >
            View subscription history
          </p>
        </div>
      </div>
    </section>
  );
};

export default SubsciptionPlan;
